import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { withSnackbar, WithSnackbarProps } from 'notistack';

import { NotificationModel } from 'models';
import { AppState } from 'store';
import { removeNotification, RemoveNotificationFunc } from 'store/notifications/actions';
import { generateDispatchToPropsMap } from 'helpers';

import { SofaSnackbar } from '@sofology/sofologycomponents';

interface OwnProps {
}

interface DispatchProps {
    removeNotification: RemoveNotificationFunc;
}

interface StateProps {
    notifications: NotificationModel[];
}

class Notifier extends Component<OwnProps & DispatchProps & StateProps & WithSnackbarProps> {
    displayedNotifications: string[] = [];

    componentDidUpdate() {
        const { notifications } = this.props;

        notifications.forEach(({ id, message, type }) => {
            if (this.displayedNotifications.includes(id)) {
                return;
            }

            this.props.enqueueSnackbar(message, {
                key: id,
                onExited: () => {
                    this.props.removeNotification(id);
                    this.removeDisplayedNotification(id);
                },
                content: () => <SofaSnackbar message={message} variant={type} />
            });

            this.storeDisplayedNotification(id);
        });
    }

    render() {
        return null;
    }

    storeDisplayedNotification(id: string) {
        this.displayedNotifications = [...this.displayedNotifications, id];
    }

    removeDisplayedNotification(id: string) {
        this.displayedNotifications = this.displayedNotifications.filter(displayedNotificationId => id !== displayedNotificationId);
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        notifications: state.notificationsState.notifications
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [removeNotification]);
}

export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(Notifier));